import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=39e8a7da&scoped=true&"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=39e8a7da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e8a7da",
  null
  
)

export default component.exports